/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Overview_Tableofcontents_Keymetrics4Inputs */

const en_coinvestments_overview_tableofcontents_keymetrics4 = /** @type {(inputs: Coinvestments_Overview_Tableofcontents_Keymetrics4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Key Metrics`)
};

/**
* | output |
* | --- |
* | "Key Metrics" |
*
* @param {Coinvestments_Overview_Tableofcontents_Keymetrics4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_overview_tableofcontents_keymetrics4 = /** @type {((inputs?: Coinvestments_Overview_Tableofcontents_Keymetrics4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Overview_Tableofcontents_Keymetrics4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_overview_tableofcontents_keymetrics4(inputs)
});
export { coinvestments_overview_tableofcontents_keymetrics4 as "coInvestments_overview_tableOfContents_keyMetrics" }